import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { PopupContentEl } from "./Popup.styles";
import type { PopupContentProps } from "./Popup.types";

/**
 *  */

const PopupContentComponent = ({
  children,
  className,
  style,
}: PopupContentProps): ReactElement => {
  return (
    <PopupContentEl className={cx(className)} style={style}>
      {children}
    </PopupContentEl>
  );
};

export const PopupContent = styled(PopupContentComponent)``;
